<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">

  <div class="row align-items-center">
    <div class="col-md-5">
      <div class="card card-success shadow-sm">
        <div class="card-header">
          <h3 class="card-title">ปริมาณน้ำฝน รายโซน {{select_list.fmcode}}-
            <select class="form-control" [(ngModel)]="select_list" (ngModelChange)="Loadraindropbyzone()">
              <option [ngValue]="" disabled>เลือกรายการ</option>
              <option *ngFor="let item of data_list" [ngValue]="item">
                {{item.fmcode}}-{{item.fmname}}
              </option>
            </select>
            <!--<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#Raindrop"
              (click)="OpenModal();">
              <i class="fas fa-plus"></i> บันทึกปริมาณน้ำฝน
            </button>-->
          </h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="table-responsive" style="max-height: 600px;">
            <table class="table table-head-fixed text-nowrap" #raindrop>
              <thead>
                <tr style="text-align:center">
                  <th scope="col">วันที่ของปี</th>
                  <th scope="col">วันที่</th>
                  <th scope="col">ปริมาณน้ำฝน</th>
                  <th scope="col">edit</th>
                  <th scope="col">แก้ไขโดย</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of zoneraindrop; " style="text-align:center"
                  [ngClass]="{'table-danger':!item.user_update}">
                  <td>{{item.dayinyear}}</td>
                  <td>{{item.date | adtob}}</td>
                  <td>
                    <b *ngIf="!item.edit">{{item.rainfall}}</b>
                    <input *ngIf="item.edit" matInput type="number" min="0" max="100" placeholder="จำนวน"
                      style="text-align:center; background: #fffcad;" [(ngModel)]="item.rainfall_edit">
                  </td>
                  <td>
                    <button *ngIf="!item.edit" type="button" class="btn btn-warning btn-sm" (click)="item.edit=true"><i
                        class="fas fa-edit"></i>
                    </button>
                    <button *ngIf="item.edit" type="button" class="btn btn-success btn-sm"
                      (click)="UpdateRaindrop2(item);item.edit=false"><i class="fa fa-save"></i>
                    </button>
                    <button *ngIf="item.edit" type="button" class="btn btn-danger btn-sm" (click)="item.edit=false"><i
                        class="fa fa-close"></i>
                    </button>
                  </td>
                  <td style="text-align: left;">
                    <i style="text-size-adjust: 4;">{{item.user_name}}</i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-7">
      <div class="card">
        <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
          [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType"
          [plugins]="lineChartPlugins">
        </canvas>
      </div>
    </div>
  </div>
  <!-- Button trigger modal -->

  <!-- Modal -->
  <div class="modal fade" id="Raindrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">เพิ่มข้อมูลปริมาณน้ำฝน</h5>
          <button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal" aria-label="Close"
            (click)="ChoseModal();">X</button>
        </div>
        <div class="modal-body">
          <form [formGroup]="AddRainDrop">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">วันที่ </span>
              <input type="date" class="form-control" formControlName="rdate">
            </div>
            <!-- <div class="input-group mb-3">
              <input type="number" class="form-control form-control-border border-width-2"
                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="5" formControlName="rcount"
                placeholder="ปริมาณน้ำฝน ตัวเลข">
            </div>-->
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">ปริมาณน้ำฝน</span>
              <input type="number" class="form-control" placeholder="ปริมาณ" aria-describedby="basic-addon1"
                formControlName="rcount">
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="ChoseModal();">Close</button>
          <button type="button" class="btn btn-primary" (click)="UpdateRaindrop();">[บันทึก]</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>